import { type MouseEvent } from 'react';
// Import from `/unstyled` so react-toastify does NOT auto-inject its stylesheet as a
// runtime <style> element (it has no nonce, so the strict `style-src` CSP blocks it —
// SER-1467). The stylesheet is loaded CSP-safely through webpack via the `@import` in
// toast.pcss below.
import { ToastContainer as ToastifyContainer } from 'react-toastify/unstyled';
import IconButton from '@common/components/controls/IconButton';
import IconCross from '@common/components/svgs/common/Cross';
import { useDarkModeContext } from '@common/containers/ApplicationContext';
import '@common/styles/components/toast.pcss';

function CloseButton(
  { closeToast }: Readonly<{ closeToast: (e: MouseEvent<HTMLElement>) => void; }>,
) {
  return <IconButton onClick={closeToast} icon={IconCross} />;
}

function ToastsContainer() {
  const { isDarkMode } = useDarkModeContext();

  return (
    <ToastifyContainer
      closeButton={CloseButton}
      position="top-right"
      newestOnTop={false}
      autoClose={false}
      rtl={false}
      pauseOnFocusLoss
      closeOnClick
      stacked
      draggable
      theme={isDarkMode ? 'dark' : undefined}
    />
  );
}

export default ToastsContainer;
